import { react } from "uikit";
import { Dispatch } from "react";

import { PaymentCountryIso } from "../../../../../../../../services/PaymentSystem";

import AssetPaymentsCountryIso from ".";

interface Context {
	value: AssetPaymentsCountryIso.Value;
	setError: Dispatch<boolean>;
}

export default class Controller extends react.ControllerBase<Context> {
	validate() {
		const isValid =
			this.context?.value.assetPaymentsCountryIso !==
			PaymentCountryIso.NULL;

		if (!isValid) {
			this.context?.setError(true);
			return isValid;
		}
		this.context?.setError(false);
		return isValid;
	}
}
